import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { message } from "@Constants/constant"
import { ConstantsContext } from "@Providers/ConstantsProvider"
import { constantTypesAtom } from "@Recoil/Atom/constantsAtom"
import { userAtom } from "@Recoil/Atom/userAtom"
import { UserService } from "@Services/User.service"
import React, { useContext, useEffect, useState } from "react"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { useRecoilState, useRecoilValue } from "recoil"
import { ConstantsFollowUpChart } from "./ConstantsFollowUpChart"
import { useIsFocused } from "@react-navigation/native"

export const ConstantsFollowUp = ({ navigation }) => {
    const [fetching, setFetching] = useState(false)
    const user = useRecoilValue(userAtom)
    const isFocused = useIsFocused()
    const [constantTypes, setConstantTypes] = useRecoilState(constantTypesAtom)
    const [loadingTypes, setLoadingTypes] = useState(false)
    const { updateList, setConstantUnites } = useContext(ConstantsContext)
    const [constantWithValues, setConstantWithValues] = useState([])
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const toggleModal = () => setOpenDeleteModal((prev) => !prev)

    const fetchConstantTypes = () => {
        setLoadingTypes(true)
        UserService.getConstantTypes()
            .then((response) => {
                const data = response.data?.data
                if (data && data instanceof Array) {
                    let parsed = []
                    data.map((item) => {
                        parsed.push({
                            ...item,
                            label: `${item.name} (${item.unit})`,
                            value: item.id
                        })
                    })
                    setConstantUnites(data?.map((item) => ({ id: item.id, unit: item.unit })))
                    setConstantTypes(parsed)
                }
                setLoadingTypes(false)
            })
            .catch(() => {
                setLoadingTypes(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const fetchConstants = () => {
        setFetching(true)
        UserService.getConstantsHistory(user?.id)
            .then((response) => {
                const dataRes = response?.data?.data
                setConstantWithValues(dataRes)
                setFetching(false)
            })
            .catch((e) => setFetching(false))
    }

    useEffect(() => {
        fetchConstants()
    }, [updateList, isFocused])

    useEffect(() => {
        fetchConstantTypes()
    }, [])

    const loading = fetching || loadingTypes
    const empty = constantWithValues?.length === 0 && !loading

    return (
        <View style={{ flex: 1, backgroundColor: baseColors.white }}>
            <View style={{ paddingHorizontal: 10 }}>
                <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                    Suivi des constantes
                </BreeSerifText>
            </View>

            {loading ? (
                <ActivityIndicator
                    style={{ alignSelf: "center", marginTop: "50%" }}
                    size={"large"}
                    color={baseColors.orange.primary}
                />
            ) : !empty ? (
                <ConstantsFollowUpChart
                    loading={loading}
                    constantWithValues={constantWithValues}
                    fetchConstants={fetchConstants}
                    setConstantWithValues={setConstantWithValues}
                    openDeleteModal={openDeleteModal}
                    toggleModal={toggleModal}
                />
            ) : (
                <CustomScrollview>
                    <View style={{ paddingHorizontal: 10 }}>
                        <OpenSansText fontSize={16}>
                            Consultez vos données ou entrez de nouvelles constantes.
                        </OpenSansText>
                        <SvgMascotte style={{ marginVertical: 20, alignSelf: "center" }} width={278} height={278} />
                        <OpenSansText fontSize={16} textAlign={"center"}>
                            Cette partie est vide... Entrez vos constantes et suivez votre évolution !
                        </OpenSansText>
                        <Spacer height={15} />
                    </View>
                </CustomScrollview>
            )}

            {!loading && (
                <View
                    style={{
                        marginBottom: 10,
                        paddingHorizontal: 20,
                        backgroundColor: "white"
                    }}
                >
                    <Button
                        disabled={loading || constantTypes?.length === 0}
                        onPress={() => navigation.navigate("ConstantFollowUpForm")}
                        text="Entrer mes constantes"
                        width="100%"
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                    {!empty && (
                        <Button
                            onPress={toggleModal}
                            text="Supprimer des constantes"
                            width="100%"
                            backgroundColor={baseColors.orange.primary}
                            labelColor={"white"}
                        />
                    )}
                </View>
            )}
        </View>
    )
}
